import React, { useState, useEffect } from 'react';
import { getCMSHomepageGrid } from '@/api/cms';
import { getOrFetchHeaderData } from '@/utils/headerCalls';
import NewPassword from '@/components/NewPassword/NewPassword';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import LoginLayout from '@/components/LoginLayout/LoginLayout';
import { getLayoutProps } from '@/utils/layout/layout';

export default function CreateNewPassword({ logo, loginLogo, loginConfig, loginImage, responsiveLogo }) {
  const [config, setConfig] = useState();
  loginImage === '' ? (loginConfig = 0) : null;

  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
      return;
    }

    getConfiguration();
  }, []);

  return (
    <>
      {config && (
        <LoginLayout type={loginConfig} image={loginImage} responsiveLogo={responsiveLogo}>
          <NewPassword config={config} logo={loginLogo ? loginLogo : logo} type={loginConfig} />
        </LoginLayout>
      )}
    </>
  );
}

export async function getStaticProps({ locale }) {
  const { responsiveLogo } = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, locale);
  const [{ data: logoData }, { data: loginLogoData }, { data: loginAllData }] = await Promise.all([
    getCMSHomepageGrid('header_logo', locale),
    getOrFetchHeaderData('login_logo', locale),
    getOrFetchHeaderData('login_page', locale),
  ]);
  const logo = logoData.data[0].content.logo.url;
  const loginLogo = loginLogoData.data[0].content.login_logo.url;
  const loginConfig = loginAllData.data[0].content.configuration;
  const loginImage = loginAllData.data[0].content.image?.url ? loginAllData.data[0].content.image?.url : '';
  const messages = {
    common: (await import(`../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_credentials: (await import(`../../../prebuild-data/i18n/${locale}/user_credentials.json`)).default,
  };
  return {
    props: {
      responsiveLogo,
      logo,
      loginLogo,
      loginConfig,
      loginImage,
      messages,
    },
  };
}
